import _sizeChartData from '../../../product/components/SizeGuide/sizeChart.json';
import { SizeChart } from '../../../product/components/SizeGuide/sizeChartTypes';

export const sizeChartData: SizeChart = _sizeChartData;

export const getDropdownOptions = (sizesArray: string[]) => {
  return sizesArray.map((size) => {
    return {
      key: size,
      text: size.toUpperCase(),
      value: size,
    };
  });
};
